/*
  Truffe & Poil : flèches « patte » posées sur l'image principale de la fiche produit.
  Elles pilotent les vignettes de Dawn : un clic équivaut à choisir la vignette
  précédente ou suivante, donc l'image principale et le compteur restent synchronisés.
  Défilé en boucle : après la dernière image on revient à la première.
*/
(function () {
  var PAW =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<ellipse cx="6.4" cy="9.6" rx="2.5" ry="3.2"/>' +
    '<ellipse cx="11.2" cy="6.7" rx="2.5" ry="3.4"/>' +
    '<ellipse cx="16.4" cy="8.2" rx="2.4" ry="3.2"/>' +
    '<path d="M11.6 12.2c3.1 0 5.6 2.2 5.6 4.6 0 2-1.8 3.2-3.8 2.7-1.2-.3-2.4-.3-3.6 0-2 .5-3.8-.7-3.8-2.7 0-2.4 2.5-4.6 5.6-4.6z"/>' +
    '</svg>';

  function thumbs(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));
  }

  function currentIndex(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  function build(gallery) {
    var viewer = gallery.querySelector('.product__media-list');
    if (!viewer || gallery.querySelector('.tp-gallery-arrow')) return;

    var stage = viewer.closest('slider-component') || viewer.parentElement;
    if (!stage) return;
    stage.classList.add('tp-gallery-stage');

    ['prev', 'next'].forEach(function (dir) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tp-gallery-arrow tp-gallery-arrow--' + dir;
      button.setAttribute('aria-label', dir === 'prev' ? 'Image pr\u00e9c\u00e9dente' : 'Image suivante');
      button.innerHTML = PAW;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var list = thumbs(gallery);
        if (list.length < 2) return;
        var index = currentIndex(list);
        var target = dir === 'next' ? index + 1 : index - 1;
        if (target < 0) target = list.length - 1;
        if (target > list.length - 1) target = 0;
        list[target].click();
      });
      stage.appendChild(button);
    });

    if (thumbs(gallery).length < 2) {
      stage.classList.add('tp-gallery-stage--single');
    }
  }

  function init() {
    document.querySelectorAll('.product__media-wrapper').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
